import { render } from "./modalNotificacao.vue?vue&type=template&id=a11581d0"
import script from "./modalNotificacao.vue?vue&type=script&lang=js"
export * from "./modalNotificacao.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__